var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tracked-ui',{staticClass:"label-hotspot",class:{
    visited: _vm.visited,
  },attrs:{"spot-config":_vm.spotConfig}},[_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.spotConfig.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }